import { PeppolUblDocumentType } from '../interfaces/peppol-item.dto';

const TAX_DOCUMENT_UBL_TYPES = [
  PeppolUblDocumentType.Invoice,
  PeppolUblDocumentType.CreditNote,
  PeppolUblDocumentType.DebitNote,
];

export function isPeppolTaxDocument(documentType?: string | null): boolean {
  return (
    !!documentType &&
    (TAX_DOCUMENT_UBL_TYPES as readonly string[]).includes(documentType)
  );
}
